import { forwardRef } from 'react'
import NumberFormat, { NumberFormatProps } from 'react-number-format'
interface MoneyFormatProps extends NumberFormatProps {
    onChange: (event: { target: { name: string; value: any } }) => void
    name: string
    allowNegative?: boolean
}

const MoneyFormat = (props: MoneyFormatProps, ref: any) => {
    const { onChange, ...other } = props
    return (
        <NumberFormat
            {...other}
            value={other.value}
            inputMode="decimal"
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.floatValue ?? null,
                    },
                })
            }}
            decimalScale={2}
            fixedDecimalScale={true}
            thousandSeparator
        />
    )
}

export default forwardRef(MoneyFormat)
